export default __webpack_public_path__ + "static/media/tripid.915b2903.jpg";